type Props = {
  options: { key: string; label: string; count: number }[];
  active: string;
  onChange: (key: string) => void;
};

export default function CategoryFilter({ options, active, onChange }: Props) {
  return (
    <div className="fold-shell">
      <div role="group" aria-label="Filter by category" className="flex flex-wrap gap-x-8 gap-y-3 border-b border-[rgba(23,21,21,0.14)] pb-4">
        {options.map((o) => {
          const on = o.key === active;
          return (
            <button
              key={o.key}
              type="button"
              aria-pressed={on}
              onClick={() => onChange(o.key)}
              className={`fold-label whitespace-nowrap cursor-pointer min-h-[44px] flex items-center gap-2 transition-opacity focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 ${on ? 'opacity-100' : 'opacity-55 hover:opacity-100'}`}
            >
              <span className={`w-1.5 h-1.5 rounded-full bg-[#171515] transition-all duration-300 ${on ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`} aria-hidden="true" />
              {o.label}
              <sup className="tabular-nums text-[9px] tracking-normal">{o.count}</sup>
            </button>
          );
        })}
      </div>
    </div>
  );
}